import { inject } from "@angular/core";
import { ADD_OCR_QUOTATION_EXPIRATION_SETTINGS_TABS } from "@app/applications/ocr/domains/ocr-quotation-expiration-settings/config/ocr-quotation-expiration-settings-dynamic-routes.config";
import { ADD_QUOTATION_EXPIRATION_SETTINGS_TABS } from "@app/applications/quotation/domains/quotation-expiration-settings/config/quotation-expiration-settings-dynamic-routes.config";
import { ADD_QUOTATION_NOTIFICATION_SETTINGS_TABS } from "@app/applications/quotation/domains/quotation-notification-settings/config/quotation-dynamic-routes.config";
import { ADD_STOCK_EXPIRATION_SETTINGS_TABS } from "@app/applications/stock/domains/stock-expiration-settings/config/stock-expiration-settings-dynamic-routes.config";
import { ADD_STOCK_NOTIFICATION_SETTINGS_TABS } from "@app/applications/stock/domains/stock-notification-settings/config/stock-dynamic-routes.config";

export function provideDynamicTabs() {
  inject(ADD_STOCK_NOTIFICATION_SETTINGS_TABS);
  inject(ADD_QUOTATION_NOTIFICATION_SETTINGS_TABS);
  inject(ADD_STOCK_EXPIRATION_SETTINGS_TABS);
  inject(ADD_QUOTATION_EXPIRATION_SETTINGS_TABS);
  inject(ADD_OCR_QUOTATION_EXPIRATION_SETTINGS_TABS);
}
